import * as React from 'react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

/**
 * Layout route for the Territories section. Renders only an `<Outlet />` so that
 * both the list (index route) and the detail route (`$territoryId`) mount correctly.
 * The list itself lives in `settings_.territories.index.tsx`.
 */
function TerritoriesLayout(): React.JSX.Element {
  return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/settings_/territories')({
  beforeLoad: ({ context }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasPermission('territories:list') &&
      !context.permissions.hasPermission('locations:list')
    ) {
      throw redirect({ to: '/settings' });
    }
  },
  component: TerritoriesLayout,
});
